var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.fileUrl
    ? _c("div", { staticClass: "preview_box" }, [
        _c("img", {
          staticClass: "preview_box_image",
          attrs: { src: _vm.fileUrl },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "preview" },
          [
            _vm._l(_vm.msg, function (item) {
              return _c("div", { key: item, staticClass: "preview_item" }, [
                _vm._v(_vm._s(item)),
              ])
            }),
            _vm._v(" "),
            _c("div", { staticClass: "preview_exit" }, [
              _c(
                "span",
                {
                  staticClass: "preview_exit_btn",
                  on: { click: () => (_vm.fileUrl = "") },
                },
                [_vm._v("退出示例")]
              ),
            ]),
          ],
          2
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }